module.exports = __webpack_public_path__ + "img/inspur.21346fa9.svg";